export default "__VITE_ASSET__Dg9B$CN___"